import axios from 'axios';
import { CONFIG } from './config';

let currentBusinessID = null;
let currentStripePK = null;

// ───────────────────────── helpers ─────────────────────────
function toNumber(value, fallback = 0) {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : fallback;
}

function extractStripePublishableKey(data) {
  if (!data || typeof data !== 'object') return null;

  const candidates = [
    data.stripe_key,
    data.stripe_pk,
    data.stripePublicKey,
    data.stripePublishableKey,
    data.stripe_publishable_key,
    data.publishable_key,
    data.publishableKey,
    data.primary_key,
    data.primaryKey,
    data.pk,
    data.key,
  ];

  const pk = candidates.find(
    value => typeof value === 'string' && /^pk_(test|live)_/.test(value)
  );

  return pk || null;
}

function getResponseData(payload) {
  if (!payload) return null;

  // Axios response: res.data.data
  if (payload?.data?.data && typeof payload.data.data === 'object') {
    return payload.data.data;
  }

  // Direct API JSON: json.data
  if (payload?.data && typeof payload.data === 'object') {
    return payload.data;
  }

  // Already data object
  if (typeof payload === 'object') {
    return payload;
  }

  return null;
}

function syncBusinessCache(payload) {
  const data = getResponseData(payload);

  if (!data || typeof data !== 'object') {
    return;
  }

  const businessID = toNumber(
    data.business_id ??
      data.businessId ??
      data.site?.business_id ??
      data.site?.businessId ??
      data.item?.business_id ??
      data.item?.businessId,
    0
  );

  if (businessID > 0) {
    currentBusinessID = businessID;
  }

  const stripePK = extractStripePublishableKey(data);

  if (stripePK) {
    currentStripePK = stripePK;
  }
}

// ───────────────────────── getters ─────────────────────────
export function getCurrentBusinessID() {
  return currentBusinessID;
}

export function getCurrentStripePK() {
  return currentStripePK;
}

export function clearDotNetBusinessCache() {
  currentBusinessID = null;
  currentStripePK = null;
}

// ───────────────────────── axios instance ─────────────────────────
export const DotNetAPI = axios.create({
  baseURL: CONFIG.dotnetURL,
  timeout: 50000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

DotNetAPI.interceptors.response.use(
  response => {
    syncBusinessCache(response);
    return response;
  },
  error => {
    const status = error?.response?.status;

    const responseMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong.';

    if (status === 401 || status === 403) {
      alert(responseMessage);
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

// ───────────────────────── app item API ─────────────────────────
export async function getAppItem(itemID) {
  const res = await DotNetAPI.get(`hireable-items/${itemID}/app`);

  syncBusinessCache(res);

  return res;
}